import React, { Component, useState } from 'react';
import axios from 'axios';
import i18n from '../../i18n';
import Errorbar from '../common/errorbar';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


class PCRestaurants extends Component { 
    constructor(props){
        super(props)
        this.state = {
            company:[],
            styles:{},
            errorMessage:"",
            openErrorBar:false,
            bodyMinHeight:0,
            companyName:"",
            showModal:false,
            benefitTxt:"",
        }
    }
    
    componentWillMount = () => {
        this.getProps()
        this.getCompanyList()
        this.handleResize()
        window.addEventListener('resize', this.handleResize)
    }

    // ページ内リンク対策
    componentDidUpdate = () => {
        if(this.state.companyName != "" ){
            var href = "/restaurants/#" + this.state.companyName.companyName
            window.location.href = href
            this.setState({companyName:""})
        }
    }

    // ホームページからもらったパラメータを取得する
    getProps = () => {
        if(typeof this.props.location.state != "undefined"){
            this.setState({companyName: this.props.location.state})
        }
    }

    // DBからデータを取得する
    getCompanyList = () => {
        var api = process.env.REACT_APP_ENDPOINT + 'restaurant'
        axios.get(api)
        .then((response)=>{
            this.setState({company:response.data})
        }).catch((error)=>{
            console.log(error)
            this.handleErrorbarOpen()
            this.setState({noDataErr:true, errorMessage:i18n.t('home.server_error')})
        })
    }

    // レスポンシブデザイン
    handleResize = () =>{
        const windowHeight = window.innerHeight
        const footerHeight = 120
        if(window.innerWidth > 1366){
            const HeaderHeight = 230
            const bodyMinHeight = windowHeight - HeaderHeight - footerHeight
            this.setState({
                styles:PCstyles,
                bodyMinHeight: bodyMinHeight
            })
        }else if(window.innerWidth <= 1366 && window.innerWidth> 1024){
            const HeaderHeight = 205
            const bodyMinHeight = windowHeight - HeaderHeight - footerHeight
            this.setState({
                styles:halfHDStyles,
                bodyMinHeight: bodyMinHeight
            })
        }
    }

    // 文字の色チェンジ
    changeColorToBlue = (e) => {
        e.currentTarget.style.color = "blue"
    }
  
    changeColorToBlack = (e) => {
        e.currentTarget.style.color = "black"
    }

    //エラー版バー
    handleErrorbarOpen=()=>{
        this.setState({openErrorBar:true})
    }

    handleErrorbarClose=()=>{
        this.setState({openErrorBar:false})
    }

    // テーブルスタイル定義
    StyledTableCell = withStyles((theme) => ({
        head: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
          fontSize: this.state.styles.font,
        },
        body: {
          fontSize: this.state.styles.font,
        },
    }))(TableCell);

    StyledTableRow = withStyles((theme) => ({
        root: {
            '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
            },
        },
    }))(TableRow);

    /** faute#2
     * 特典表示用ダイアログ処理 feauter#2 
     * benefits    ：特典　有無
     * benefit_det ：特典の詳細内容
     * */
    benefit = (benefits,benefit_det)=>{
        if(benefits===0){
            /** 特典なし*/
            return(<div><h4>ー</h4></div>);
        }else{
            /** 特典あり */
            return(
                <div>
                    <Button 
                        variant="outlined"
                        color="primary"
                        onClick={()=>this.handleOpen(benefit_det)}>
                            〇
                    </Button>
                </div>
            )
        }
    }
    /** faute#2
     * 特典ダイアログを表示状態にし、表示する文字列を変更する
     * benefit_det  ：特典の詳細内容
     */
    handleOpen = (benefit_det)=>{
        /**
         * MySQLに改行コード（\n）入れると、通常文字として扱う為か、
         * (\\n)で保存される場合があるので改行コードに置換する処理を入れる。
         * 改行処理はCSSの機能で対応する
         */
         console.log("pure bene::",benefit_det);
         let brText = benefit_det.replace(/\\n/g,'\n');
        /**
         *  ステートの表示用文字列変数にセットする
         */
        this.setState({benefitTxt: brText});
        console.log("benefit Txt::",this.state.benefitTxt);
        /**
         *  ステートの表示状態変数をon(true）にする  
         * */ 
         this.setState({showModal: true});
        }

    render(){
        /** 
         * 特典ダイアログを消す。faute#2
         * 表示状態のステータス「showModal」を「OFF（false）」にする
        */
        let handleClose = ()=>{
            //　console.log(">>render.handleClose");
            this.setState({showModal: false});
        }
    
        // 画面左側の企業一覧作成
        var companys = this.state.company.map((item,index) => {
            var href = "/restaurants/#" + item.name
            return(
                <div key={index}>
                    <p style={this.state.styles.companyName}>
                        <a href={href} style={{color:"black"}} onMouseOver={this.changeColorToBlue} onMouseOut={this.changeColorToBlack}>{item.name}</a>
                    </p>
                    <br/>
                </div>
            );
        })

        // 店舗一覧テーブルのヘッダーを定義
        var tableHead = [
            <TableHead>
                <TableRow>
                    <this.StyledTableCell style={{width:"20%"}}>{i18n.t('restaurants.store_name')}</this.StyledTableCell>
                    <this.StyledTableCell align="left" style={{width:"17%"}}>{i18n.t('restaurants.phone_number')}</this.StyledTableCell>
                    <this.StyledTableCell align="left" style={{width:"38%"}}>{i18n.t('restaurants.address')}</this.StyledTableCell>
                    <this.StyledTableCell align="left" style={{width:"10%"}}>{i18n.t('restaurants.benefits')}</this.StyledTableCell>
                    <this.StyledTableCell align="left">{i18n.t('restaurants.info_url')}</this.StyledTableCell>
                </TableRow>
            </TableHead>
        ];

        // 店舗一覧テーブル作成
        var stores = this.state.company.map((item,index) => {
            // 店舗が登録されていない場合
            if(item.storeList.length == 0){
                return(
                    <div key={index}>
                        <p id={item.name} style={this.state.styles.tableTitle}>■ {item.name}</p>
                        <p style={this.state.styles.noDataMessage}>{i18n.t('restaurants.no_store_message')}</p>
                    </div>
                )
            }
            // accessUrlが登録されている
            var comanyStores = item.storeList.map((_item,_index) => {
                return(
                    <this.StyledTableRow key={_item.name}>
                        <this.StyledTableCell component="th" scope="row">
                            {_item.name}
                        </this.StyledTableCell>
                        <this.StyledTableCell align="left">{_item.phoneNumber}</this.StyledTableCell>
                        <this.StyledTableCell align="left">{_item.address}</this.StyledTableCell>
                        <this.StyledTableCell align="left">{
                            /** 特典　カラム表示 fauter#2 */
                            this.benefit(_item.benefits,_item.benefit_det)
                        }</this.StyledTableCell>
                        <this.StyledTableCell align="left">{
                            _item.info_url == null ? <p>―</p> : 
                            <a href={_item.info_url} target="_blank">{i18n.t('restaurants.click_to_access')}</a>
                        }</this.StyledTableCell>
                    </this.StyledTableRow>
                )
            });
            return(
                <div key={index}>
                    <p id={item.name} style={this.state.styles.tableTitle}>■ {item.name}</p>
                    <Table style={this.state.styles.tableAera} aria-label="customized table">
                        {tableHead}
                        <TableBody>
                            {comanyStores}
                        </TableBody>
                    </Table>
                </div>  
            )
            }
        );
        //
        return(
            <div style={{minHeight:this.state.bodyMinHeight}}>
                <Errorbar open={this.state.openErrorBar} handleClose={this.handleErrorbarClose} message={this.state.errorMessage} />
                <div style={{position:"absolute", width:"20%"}}>
                    <div>
                        {companys}
                    </div>
                </div>
                <div style={{marginBottom:"50px"}}>
                    {stores}
                </div>
                <div> {/** 特典表示用ダイアログ fature#2*/}
                    <Dialog
                        open={this.state.showModal}
                        onClose={handleClose}
                        fullWidth={this.state.styles.benefitDialog.fullWidth}
                        maxWidth={this.state.styles.benefitDialog.maxWidth}
                        aria-labelledby="alert-dialog-title"
                        aria-decsribedby="alert-dialog-description"
                    >
                        {/** ダイアログのタイトル ”特典” */}
                        <DialogTitle id="alert-dialog-title">
                            {i18n.t('resBenefits.title_txt')}
                        </DialogTitle>
                        {/** ダイアログの内容  */}
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" variant="h6">
                                {/** whiteSpace:"pre-warp" で改行コード(\n)で改行表示させる事が出来る */}
                                <p style={{whiteSpace:"pre-wrap"}}>{this.state.benefitTxt}</p>
                            </DialogContentText>
                            {/** ダイアログ終了用のボタン[OK] */}
                            <DialogActions>
                                <Button onClick={handleClose} color="primary">{i18n.t('resBenefits.closeModal')}</Button>
                            </DialogActions>
                        </DialogContent>
                    </Dialog>
                {/** 特典　ダイアログ終了 */}
                </div>
                <a href="#">
                    <button className="returnTopButton" style={this.state.styles.returnTopButton}>
                        <ArrowUpwardIcon style={{color:"black"}}/>
                    </button>
                </a>
            </div>
        )
    }
}

const PCstyles = {
    companyName: {
        margin:"5px 30%", 
        fontSize:"19px",
        fontWeight:"700",
        textDecoration:"underline"
    },
    tableTitle: {
        marginLeft:"25%", 
        marginTop:"50px", 
        fontSize:"20px"
    },
    tableAera: {
        width:"60%", 
        marginLeft:"25%"
    },
    font: 17,
    noDataMessage: {
        fontSize:"19px",
        color:"red",
        marginLeft:"25%"
    },
    returnTopButton:{
        position:"fixed", 
        bottom:"18px", 
        right:"2%", 
        height:"40px", 
        width:"40px", 
        background:"white"
    },
    benefitDialog:{
        fullWidth:"true",
        maxWidth:"md",
    }
};

const halfHDStyles = {
    companyName: {
        margin:"5px 30%", 
        fontSize:"17px",
        fontWeight:"700",
        textDecoration:"underline"
    },
    tableTitle: {
        marginLeft:"22%", 
        marginTop:"50px", 
        fontSize:"20px"
    },
    tableAera: {
        width:"70%", 
        marginLeft:"22%"
    },
    font: 15,
    noDataMessage: {
        fontSize:"17px",
        color:"red",
        marginLeft:"22%"
    },
    returnTopButton:{
        position:"fixed", 
        bottom:"18px", 
        right:"2%", 
        height:"40px", 
        width:"40px", 
        background:"white"
    },
    benefitDialog:{
        fullWidth:"true",
        maxWidth:"xs",
    }
};

export default withRouter(PCRestaurants);